import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { ContentBox, ContentBoxHead, ContentCollapser, ContentBoxBody } from '../ContentBox/ContentBox';
import TeleScript from '../TeleScript/TeleScript';
import isHash from '../../utils/isHash';
import headingPlainText from '../../utils/headingPlainText';
var boxedContentTitleId = 0;
var visibleText = function (node) {
    if (node == null || typeof node === 'boolean') {
        return '';
    }
    if (typeof node === 'string' || typeof node === 'number') {
        return headingPlainText(String(node));
    }
    if (Array.isArray(node)) {
        return headingPlainText(node
            .map(function (child) { return visibleText(child); })
            .filter(Boolean)
            .join(' '));
    }
    if (!React.isValidElement(node)) {
        return '';
    }
    var props = node.props;
    if (node.type === TeleScript) {
        var fromLine = headingPlainText(props.line);
        if (fromLine) {
            return fromLine;
        }
    }
    return visibleText(props.children);
};
/**
 * A simple component what could help us to create content box based sections.
 */
var BoxedContent = function (_a) {
    var hash = _a.hash, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.variant, variant = _c === void 0 ? 'theme-primary' : _c, _d = _a.hasCollapser, hasCollapser = _d === void 0 ? true : _d, _e = _a.isActive, isActive = _e === void 0 ? true : _e, _f = _a.isVisible, isVisible = _f === void 0 ? true : _f, children = _a.children, ariaLabel = _a.ariaLabel;
    var titleIdRef = useRef(null);
    if (titleIdRef.current === null) {
        boxedContentTitleId += 1;
        titleIdRef.current = "boxed-content-title-".concat(boxedContentTitleId);
    }
    var titleId = titleIdRef.current;
    if (!isVisible)
        return null;
    var scrapedTitle = typeof title === 'string' ? headingPlainText(title) : visibleText(title);
    var ariaLabelledBy = !ariaLabel || scrapedTitle ? titleId : undefined;
    return (_jsxs(ContentBox, { id: hash, show: isHash(hash) || !hasCollapser || isActive ? 'true' : 'false', variant: variant, children: [_jsxs(ContentBoxHead, { children: [_jsx("div", { id: titleId, children: typeof title === 'string' ? _jsx("div", { dangerouslySetInnerHTML: { __html: String(title) } }) : title }), hasCollapser === true ? _jsx(ContentCollapser, { ariaLabelledBy: ariaLabelledBy, ariaLabel: ariaLabelledBy ? undefined : ariaLabel }) : ''] }), _jsx(ContentBoxBody, { children: children })] }));
};
export default BoxedContent;
